module.exports = __webpack_public_path__ + "img/dashboards-w.svg";